import React, { useEffect, useState } from "react";
import { json2csv } from 'json-2-csv';
import { Col, FormGroup, Input, Label, Row, Table } from "reactstrap";
import profile from "../../assets/Group 16 (1).png";
import Select from "react-select";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { getQR } from "./GenerateQR";
function Dashboard() {
  const [districtName, setDistrictName] = useState(null);
  const [blockList, setBlockList] = useState([]);
  const [userBlock, setUserBlocks] = useState([]);
  const [farmerJson,setFarmerJson] =useState([]);
  const [isLoadingTrue,setLoadingTrue]= useState(false);
  const [isFormDivVisble,setFormDivVisible] = useState(true);
  const [isListButtonVisible,setListButtonVisible] = useState(false);
  const [requestingFarmerIdsNumber,setRequestingFarmerIdsNumber] = useState(150);
  const [tableData,setTableData] = useState([]);
  const [totalCompleted,setTotalCompleted] = useState(0);
  const [isTableDataLoading,setTableDataLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [mobileCompany,setMobileCompany] = useState(null);
  const [mobileModel,setMobileModel] = useState(null);
  const [mobileInfoUpdatingLoadingTrue,setmobileInfoUpdatingLoadingTrue] = useState(false);
  const [qrUri,setQrUri] = useState(null);
  const toggle = () => setModal(!modal);
  const [isGeneratingQRCodeTrue,setGeneratingQRCodeTrue] =useState(false);
  // const [isFarmerIdsQuotaCompleted,setFarmerIdsQuotaCompleted] = useState(false);
  const navigate = useNavigate();
  const districts = [
    { value: "ANGUL", label: "Angul" },
    { value: "BALASORE", label: "Balasore" },
    { value: "BARGARH", label: "Bargarh" },
    { value: "BHADRAK", label: "Bhadrak" },
    { value: "BOUDH", label: "Boudh" },
    { value: "BOLANGIR", label: "Bolangir" },
    { value: "CUTTACK", label: "Cuttack" },
    { value: "DEOGARH", label: "Deogarh" },
    { value: "DHENKANAL", label: "Dhenkanal" },
    { value: "GAJAPATI", label: "Gajapati" },
    { value: "GANJAM", label: "Ganjam" },
    { value: "JAGATSINGHAPUR", label: "Jagatsinghpur" },
    { value: "JAJPUR", label: "Jajpur" },
    { value: "JHARSUGUDA", label: "Jharsuguda" },
    { value: "KALAHANDI", label: "Kalahandi" },
    { value: "KANDHAMAL", label: "Kandhamal" },
    { value: "KENDRAPARA", label: "Kendrapara" },
    { value: "KENDUJHAR", label: "Kendujhar" },
    { value: "KHURDHA", label: "Khurdha" },
    { value: "KORAPUT", label: "Koraput" },
    { value: "MALKANGIRI", label: "Malkangiri" },
    { value: "MAYURBHANJ", label: "Mayurbhanj" },
    { value: "NAWARANGPUR", label: "Nawarangpur" },
    { value: "NAYAGARH", label: "Nayagarh" },
    { value: "NUAPADA", label: "Nuapada" },
    { value: "PURI", label: "Puri" },
    { value: "RAYAGADA", label: "Rayagada" },
    { value: "SAMBALPUR", label: "Sambalpur" },
    { value: "SONEPUR", label: "Sonepur" },
    { value: "SUNDERGARH", label: "Sundergarh" }    
  ];
  const handleChange = (selectedOption) => {
    setDistrictName(selectedOption.value);
  };
  // console.log("district name", userBlock);
  const inputStyle = {
    borderRadius: "15px",
    boxShadow: "none",
    marginTop: 20,
    paddingLeft: 0,
    height: 10,
    fontWeight: 500,
    color: "#0a3b0a",
    fontSize: 14,
    border: "1.35px solid #079015",
  };
// useEffect(()=>{
//   if(localStorage.getItem("mobile_model")=='null'){
// toggle()
//   }
// },[])
useEffect(()=>{
  if(localStorage.getItem("odkToken")!='null'){
    setQrUri(getQR(localStorage.getItem("odkToken")))
  }
})
// console.log("qr uri----",qrUri)
const updateMobileInfo = async() =>{
  setmobileInfoUpdatingLoadingTrue(true);
  await axios.post('https://u3hb19hsxc.execute-api.us-east-1.amazonaws.com/mobile-info',
    {
      mobile_company:mobileCompany,
      mobile_model:mobileModel,
      id:localStorage.getItem("enumerator_id")
    }
  )
  .then((resp)=>{
    // console.log("mobile_model data",resp?.data)
    localStorage.setItem("mobile_model",resp?.data?.body[0]?.mobile_model);
    setmobileInfoUpdatingLoadingTrue(false)
    toggle()
  })
  .catch((err)=>{
    console.log('something went wrong',err);
    setmobileInfoUpdatingLoadingTrue(false)
  })
}
// console.log(localStorage.getItem("mobile_model")=='null')
  useEffect(() => {
    if (districtName) {
      axios
        .post(
          "https://lgwwxqoydg.execute-api.us-east-1.amazonaws.com/getBlocks",
          {
            districtName: districtName,
          }
        )
        .then((resp) => {
          // console.log("Response data", resp?.data?.body);
          const blocks = [];
          resp?.data?.body?.map((item) => {
            // console.log(item?.block, item?.available_ids);
            blocks.push({
              value: `${item?.block}`,
              label: `${item?.block} - ${item?.available_ids}`,
            });
          });
          setBlockList(blocks);
        })
        .catch((err) => {
          console.log("error in getting blocks", err);
        });
    }
  }, [districtName]);
  const handleAddBlocks = (selectedOption) => {
    // console.log(selectedOption)
    setUserBlocks(selectedOption);
  };


  const handleGetFarmerIds = ()=>{
    setLoadingTrue(true);
    axios.post('https://p72qgsdzob.execute-api.us-east-1.amazonaws.com/farmer_ids',{
      districtName:districtName,
      blockNames:userBlock,
      enumeratorId:localStorage.getItem("enumerator_id"),
      limit:requestingFarmerIdsNumber
    })
    .then((resp)=>{
      console.log(resp?.data?.body);
      setFarmerJson(resp?.data?.body)
      setLoadingTrue(false);
      setListButtonVisible(true);
      setDistrictName(null)
      setUserBlocks([])
    })
    .catch((err)=>{
      console.log("something went wrong while fetching the farmer'ids--",err)
      setLoadingTrue(false);
    })
  }
  // console.log("farmer json file",farmerJson)
      const downloadCSV = async (jsonData) => {
        setLoadingTrue(true)
        if (!jsonData || jsonData.length === 0) {
          setLoadingTrue(false)
          console.error('No JSON data provided or data is empty.');
          return;
        }
    
        // Extract headers
        const headers = Object.keys(jsonData[0]);
    
        // Map JSON to CSV rows
        const csvRows = jsonData.map(row =>
          headers.map(header => `"${row[header] || ''}"`).join(',')
        );
    
        // Combine headers and rows
        const csvString = [headers.join(','), ...csvRows].join('\n');
    
        // Create a Blob from the CSV string
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    
        // Create a link to download the Blob as a file
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute('download', 'Farmer-List.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoadingTrue(false)
      };

  
      useEffect(()=>{
        if(!localStorage.getItem("Mobile")){
          navigate("/login");
        }
        },[])

  const handleGetProfile = async() =>{
    setTableDataLoading(true);
    await axios.post('https://nnii22z3ze.execute-api.us-east-1.amazonaws.com/profile',{
      name:localStorage.getItem("name")
    })
    .then((resp)=>{
      // console.log(resp?.data?.body)
      var jsonDataa =[]
      var totalCompletedCount =0;
      if(resp?.data?.body.length>0){
        setTableData(resp?.data?.body)
      resp?.data?.body.map((item)=>{
        if(item?.isCompleted){
          totalCompletedCount=totalCompletedCount+1;
        }
       jsonDataa.push({
        "District Name":item?.district_name,
        "Block Name":item?.block,
        "Village Name":item?.village,
        "Ward Name":item?.ward,
        "Crop Name":item?.crop_name,
        "Form Id":item?.id,
        "Farmer Name":item?.name,
        "Farmer Primary Mobile Number":item?.mobile,
        "Farmer Alternate Mobile Number":item?.field_mob,
        "isCompleted":item?.isCompleted,
        "Data Type":item?.data_type
       })
      })
      setTotalCompleted(totalCompletedCount)
    }
      setTableDataLoading(false);
    })
    .catch((err)=>{
      console.log("something went wrong",err)
      setTableDataLoading(false);
    })
  }
  useEffect(()=>{
handleGetProfile()
  },[])
  const handleLogout= ()=>{
    localStorage.removeItem("Mobile");
    localStorage.removeItem("enumerator_id");
    localStorage.removeItem("name");
    localStorage.removeItem("mobile_model");
    localStorage.removeItem("odkToken")
    navigate("/login");
  }
  // console.log(tableData)

  const handleUpdateFarmerId = async (id) =>{
    await axios.post('https://xgpzh6acw8.execute-api.us-east-1.amazonaws.com/update-id',
      {
        farmerId:id
      }
    )
    .then((resp)=>{
      console.log(resp?.data)
    })
    .catch((err)=>{
      console.log(err);
    })
  }


 const generatorUserQr = async () =>{
  setGeneratingQRCodeTrue(true);
  axios.post('https://mmh3yvll68.execute-api.us-east-1.amazonaws.com/generateQR',
    {
      displayName : localStorage.getItem("name")+"-"+localStorage.getItem("Mobile"),
      enumerator_id:localStorage.getItem("enumerator_id")
    }
  )
  .then((resp)=>{
     console.log(resp?.data)
     setQrUri(getQR(resp?.data?.body?.token))
     setGeneratingQRCodeTrue(false);
     localStorage.setItem("odkToken",resp?.data?.body?.token);
  })
  .catch((err)=>{
    setGeneratingQRCodeTrue(false);
    console.log('something went wrong',err);
  })
 }

  return (
    <div className="dashboard-main">
      <Row className="mt-2" style={{ justifyContent: "center" }}>
        <center>

        <h5 className="home-main-heading">
          Rice Fallow Management Baseline Survey
        </h5>
        </center>
      </Row>
      <Row>
        <Col md="3">
          <div className="profile-div">
            <center>
              <img src={profile} />
              <h5 className="profile-name">{localStorage.getItem("name")}</h5>
              <p style={{marginTop:-15,fontSize:11}}>Total Completed = {totalCompleted}</p>
              <div>
              <div className="select-location">
                <Select
                  options={districts}
                  isMulti={false}
                  onChange={handleChange}
                  placeholder="Select district"
                />
                <Select
                  options={blockList}
                  inputStyle={inputStyle}
                  onChange={handleAddBlocks}
                  className="mt-2"
                  isMulti={true}
                  placeholder="Select blocks"
                />
              </div>
<button className="home-button mt-3 mb-2" onClick={handleGetFarmerIds}>{isLoadingTrue?'Loading...':'Submit'}</button>
              
              </div>

              {
                isListButtonVisible &&
                <button className="home-button mt-3 mb-2" onClick={()=>downloadCSV(farmerJson)}>{isLoadingTrue?'Downloading...':'Download List'}</button>
              }
            </center>
            <center>
              {
                !qrUri?
              
              <button className="home-button mt-3 mt-2" onClick={()=>generatorUserQr()}>{isGeneratingQRCodeTrue?'Generating...':'Generate QR'}</button>
              :
              <div>
            <center>
            <p style={{ marginTop: 10,fontSize:14 }}>Please scan it on your ODK Collect.</p>
            <img style={{ width: 200, height: 200 }} src={qrUri} alt="QR Code" />
            <p style={{ marginTop: 10,display:'flex',justifyContent:'space-evenly' }}>
              <a href={qrUri} download="rfm-ODK-QRCode.jpg">
                <Button style={{marginLeft:5,background:'#353D99',fontSize:11,width:110}}   size="sm">
                  Download QR
                </Button>
              </a>
            <a href="https://play.google.com/store/apps/details?id=org.odk.collect.android&hl=en&gl=US" target="_blank">
                <Button size="sm" style={{marginLeft:5,background:'#c0810f',fontSize:11,width:110}} className="submitButton">
                  Get ODK Collect
                </Button>
              </a>
              
            </p>
            </center>
          </div>
}
            </center>
            <center>
            </center>
            <center>
              <button style={{background:'red'}} className="home-button mt-3 mt-2" onClick={handleLogout}>Logout</button>
            </center>
          </div>
        </Col>
        <Col md="9">
        <div className="table-div">
        <Table
        >
           <thead>
    <tr>
      <th>
      District Name
      </th>
      <th>
      Block Name
      </th>
      <th>
      Village Name
      </th>
      <th>
      Ward Name
      </th>
      <th>
      Crop Name
      </th>
      <th>
      Form Id
      </th>
      <th>
      Farmer Name
      </th>
      <th>
      Farmer Mobile Number
      </th>
      <th>
        Data Type
      </th>
      <th>
        is Completed
      </th>
    
      <th>
        Modify
      </th>
    </tr>
  </thead>
  {
    isTableDataLoading ?
    <center><p style={{width:100}}>Loading...</p></center>
  :
  <tbody>
    {
      tableData.map((item)=>{
        return(
          <tr>
          <td>
            {item?.district_name}
          </td>
          <td>
          {item?.block}
          </td>
          <td>
          {item?.village}
          </td>
          <td>
            {item?.ward}
          </td>
          <td>
            {item?.crop_name}
          </td>
          <td>
            {item?.id}
          </td>
          <td>
            {item?.name}
          </td>
          <td>
            {item?.mobile}
          </td>
          <td>
            {item?.data_type}
          </td>
          <td>
             <FormGroup check>
              {
               item?.isCompleted ?
    <Input
    id="exampleCheck"
    name="check"
    type="checkbox"
    checked={item?.isCompleted}
    />
    :
    <Input
    id="exampleCheck"
    name="check"
    type="checkbox"
    />
  }
  </FormGroup>
          </td>
          <td>
          <button className="home-button mt-3 mb-2" onClick={()=>handleUpdateFarmerId(item?.id)} disabled={item?.isCompleted} style={!item?.isCompleted?{fontSize:13,width:'130px'}:{fontSize:13,width:'130px',backgroundColor:'grey'}} >Update</button>
          </td>
        </tr>
        )
      })
    }
    </tbody>
}
          </Table>
        </div>
        </Col>
      </Row>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalBody>
          <center>
<h6 className="mt-3">Mobile Camera Specification Info</h6>
        <input
            className="login-input mt-4"
            style={{width:'90%'}}
            value={mobileCompany}
            onChange={(e)=>setMobileCompany(e.target.value)}
            placeholder="Mobile Company Names"
            />
              <input
              value={mobileModel}
              onChange={(e)=>setMobileModel(e.target.value)}
            className="login-input mt-4"
            style={{width:'90%'}}
            placeholder="Mobile Company Model"
            />
              <button
            className="home-button mt-3 mb-3"
            onClick={updateMobileInfo}
          >
            {mobileInfoUpdatingLoadingTrue ? 'Loading':'Submit'}
          </button>
            </center>
        </ModalBody>
        <ModalFooter>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default Dashboard;
